module.exports = __webpack_public_path__ + "static/img/card2.f4ed816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/card2.jpg
// module id = u4Ka
// module chunks = 0